/**
 * Created by minimus on 07.08.2016.
 */
(function ($) {
  $(document).ready(function () {
    const spPointer = samProPointerOptions;
    const pObject = $('#menu-plugins');

    pObject.pointer({
      content: "<h3>" + spPointer.title + "</h3>" + spPointer.content,
      position: spPointer.position,
      pointerWidth: 400,
      close: function () {
        $.ajax({
          url: ajaxurl,
          data: {
            action: 'close_sam_pro_pointer',
            pointerKey: spPointer.key
          },
          async: true
        });
      }
    }).pointer('open');
  });
})(jQuery);
